import LDialog from './LDialog.vue'

export default (Vue) => {
  Vue.component(LDialog.name, LDialog)
}
